"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateProjectArguments = exports.CreateProjectOptions = void 0;
exports.CreateProjectOptions = [
    {
        name: "runtime",
        type: "string",
        description: "Microsoft 365 Agents Toolkit: select runtime for your app",
        default: "node",
        hidden: true,
        choices: ["node", "dotnet"],
    },
    {
        name: "capability",
        questionName: "capabilities",
        type: "string",
        shortName: "c",
        description: "Specifies the app feature.",
        required: true,
        choices: [
            "empty",
            "bot",
            "notification",
            "command-bot",
            "workflow-bot",
            "tab-non-sso",
            "sso-launch-page",
            "dashboard-tab",
            "tab-spfx",
            "search-app",
            "collect-form-message-extension",
            "search-message-extension",
            "link-unfurling",
            "declarative-agent",
            "custom-copilot-basic",
            "custom-copilot-rag",
            "custom-copilot-agent",
            "message-extension",
            "BotAndMessageExtension",
            "TabNonSsoAndBot",
            "json-taskpane",
            "office-content-addin",
        ],
        choiceListCommand: "atk list templates",
    },
    {
        name: "bot-host-type-trigger",
        type: "string",
        shortName: "t",
        description: "Specifies the trigger for `Chat Notification Message` app template.",
        default: "http-express",
        choices: [
            "http-express",
            "http-webapi",
            "http-and-timer-functions",
            "http-functions",
            "timer-functions",
        ],
    },
    {
        name: "spfx-solution",
        type: "string",
        shortName: "s",
        description: "Create a new or import an existing SharePoint Framework solution.",
        default: "new",
        choices: ["new", "import"],
    },
    {
        name: "spfx-install-latest-package",
        type: "boolean",
        description: "Install the latest version of SharePoint Framework.",
        default: true,
    },
    {
        name: "spfx-framework-type",
        type: "string",
        shortName: "k",
        description: "Framework.",
        default: "react",
        choices: ["react", "minimal", "none"],
    },
    {
        name: "spfx-webpart-name",
        type: "string",
        shortName: "w",
        description: "Name for SharePoint Framework Web Part.",
        default: "helloworld",
    },
    {
        name: "spfx-folder",
        type: "string",
        description: "Directory or Path that contains the existing SharePoint Framework solution.",
    },
    {
        name: "me-architecture",
        type: "string",
        shortName: "m",
        description: "Architecture of Search Based Message Extension.",
        default: "new-api",
        choices: ["new-api", "api-spec", "bot"],
    },
    {
        name: "with-plugin",
        type: "string",
        description: "Whether to add API plugin for your declarative Copilot.",
        default: "no",
        choices: ["no", "yes"],
    },
    {
        name: "api-plugin-type",
        type: "string",
        description: "API plugin type.",
        default: "new-api",
        choices: ["new-api", "api-spec", "existing-plugin"],
    },
    {
        name: "plugin-manifest-path",
        type: "string",
        description: "Plugin manifest path.",
    },
    {
        name: "plugin-opeanapi-spec-path",
        type: "string",
        description: "OpenAPI description document used for your API plugin.",
    },
    {
        name: "api-auth",
        type: "string",
        description: "The authentication type for the API.",
        default: "none",
        choices: ["none", "api-key", "bearer-token", "microsoft-entra", "oauth"],
    },
    {
        name: "custom-copilot-rag",
        type: "string",
        description: "Chat With Your Data",
        default: "custom-copilot-rag-customize",
        choices: [
            "custom-copilot-rag-customize",
            "custom-copilot-rag-azureAISearch",
            "custom-copilot-rag-customApi",
            "custom-copilot-rag-microsoft365",
        ],
    },
    {
        name: "openapi-spec-location",
        type: "string",
        shortName: "a",
        description: "OpenAPI description document location.",
    },
    {
        name: "api-operation",
        type: "array",
        shortName: "o",
        description: "Select operation(s) Teams can interact with.",
    },
    {
        name: "custom-copilot-agent",
        type: "string",
        description: "AI Agent",
        default: "custom-copilot-agent-new",
        choices: ["custom-copilot-agent-new", "custom-copilot-agent-assistants-api"],
    },
    {
        name: "programming-language",
        type: "string",
        shortName: "l",
        description: "Programming Language",
        default: "javascript",
        choices: ["javascript", "typescript", "csharp", "python"],
    },
    {
        name: "llm-service",
        type: "string",
        description: "Service for Large Language Model (LLM)",
        default: "llm-service-azure-openai",
        choices: ["llm-service-azure-openai", "llm-service-openai"],
    },
    {
        name: "azure-openai-key",
        type: "string",
        description: "Azure OpenAI Key",
    },
    {
        name: "azure-openai-endpoint",
        type: "string",
        description: "Azure OpenAI Endpoint",
    },
    {
        name: "azure-openai-deployment-name",
        type: "string",
        description: "Azure OpenAI Deployment Name",
    },
    {
        name: "openai-key",
        type: "string",
        description: "OpenAI Key",
    },
    {
        name: "folder",
        type: "string",
        shortName: "f",
        description: "Directory where the project folder will be created in.",
        required: true,
        default: "./",
    },
    {
        name: "app-name",
        type: "string",
        shortName: "n",
        description: "Application Name",
        required: true,
    },
];
exports.CreateProjectArguments = [];
//# sourceMappingURL=CreateProjectOptions.js.map